import { render, staticRenderFns } from "./xhyAdvert.vue?vue&type=template&id=566d0296&scoped=true&"
import script from "./xhyAdvert.vue?vue&type=script&lang=js&"
export * from "./xhyAdvert.vue?vue&type=script&lang=js&"
import style0 from "./xhyAdvert.vue?vue&type=style&index=0&id=566d0296&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566d0296",
  null
  
)

export default component.exports